import React from 'react';
import { useInterimsLoaderByDate } from 'common/components/SessionHistory/hooks/useInterimsLoaderByDate';

import { useInterimSelection } from './hooks/useInterimSelection';
import { useInterimSelectionRange } from './hooks/useInterimSelectionRange';
import { useInterimsTimeRange } from './hooks/useInterimsTimeRange';
import { InterimsTimelineContext } from 'src/common/components/Graphs/Interims/InterimsTimelineContext';

export type InterimsTimelineProviderProps = {
  sessionStart: Date;
  sessionEnd: Date;
  children: React.ReactNode;
  imsi?: number;
  sessionId?: string | null;
};

export const InterimsTimelineProvider: React.FC<InterimsTimelineProviderProps> = ({
  children,
  imsi,
  sessionId,
  sessionStart,
  sessionEnd,
}) => {
  const { selectedRange } = useInterimsTimeRange();

  const {
    timeline: interimsTimeline,
    interims,
    isFetching: fetchingInterims,
  } = useInterimsLoaderByDate(imsi, sessionId, sessionStart, sessionEnd, selectedRange.from);

  const {
    startInterim,
    selectedInterimId,
    markedInterimId,
    selectedInterim,
    selectInterimById,
    selectStartInterim,
    unselectInterim,
    markSelectedInterimAsDefault,
  } = useInterimSelection(interims || []);

  const { markedInterimStart, markedInterimStop } = useInterimSelectionRange(
    markedInterimId,
    interimsTimeline,
  );

  const startInterimMarked = markedInterimId === startInterim?.id;

  return (
    <InterimsTimelineContext.Provider
      value={{
        interimsTimeline,
        fetchingInterims,
        startInterim,
        selectedInterimId,
        selectedInterim,
        startInterimMarked,
        markedInterimStart,
        markedInterimStop,

        selectStartInterim,
        selectInterimById,
        unselectInterim,
        markSelectedInterimAsDefault,

        sessionStart,
        sessionEnd,
      }}
    >
      {children}
    </InterimsTimelineContext.Provider>
  );
};
